<template>
  <div id="invest-modal">
    <div class="bg-light sticky-top w-100">
      <b-button
        variant="light"
        @click="$emit('closePanel', { closedBy: 'bg' })"
      >
        <close-icon />
      </b-button>
      <div class="wrap py-3 d-inline-block">
        <h6 class="mb-0">
          {{ subscription.location.locationname }} Farm Reports
        </h6>
      </div>
    </div>
    <div
      class="thumb bg-dark shadow-xl bg-cover text-white position-relative"
      style="height:2px;"
      :style="{
        backgroundImage: ` linear-gradient(0deg, rgba(0,0,0,0.6), transparent), url('https://agbeloba-media.s3.amazonaws.com/057a2dc9-9714-40ad-8482-abf38fd629ca.jpg')`
      }"
    ></div>
    <div class="land-location p-3" style="height: 100%; overflow-y: scroll">
      <b-row>
        <b-col>
          <h6 class="mb-0">
            {{ formatMoney(subscription.amount) }}
          </h6>
          <small variant="primary">Cost of land</small>
        </b-col>
        <b-col>
          <h6 class="mb-0">
            {{
              LuxonDateTime.fromJSDate(
                new Date(subscription.createdat)
              ).toFormat("LLL dd yyyy")
            }}
          </h6>
          <small variant="primary">Purchase date</small>
        </b-col>
      </b-row>

      <hr class="mt-3 mb-3" />

      <b-row>
        <b-col>
          <h6 class="mb-0">
            {{ subscription.location.locationname }}
          </h6>
          <small variant="primary">Location</small>
        </b-col>
        <b-col>
          <h6 class="mb-0">
            {{ subscription.units }}
          </h6>
          <small variant="primary"
            >Plot{{ subscription.units !== 1 ? "s" : "" }} purchased</small
          >
        </b-col>
      </b-row>

      <hr class="mt-3 mb-3" />

      <b-row v-if="subscription.farmmanagements.length > 0">
        <b-col
          class="mb-3"
          cols="12"
          v-for="mgt of subscription.farmmanagements"
          :key="mgt.id"
        >
          <div
            class="d-flex bg-white dash-card p-5 align-items-center justify-content-center shadow-2xl"
            style="height:200px"
          >
            <div class="wrap text-center">
              <h5 class="mb-0">
                {{ mgt.farmservice.farmingname }}
              </h5>
              <small
                >Planted on {{ mgt.farmunits }} plot{{
                  mgt.farmunits !== 1 ? "s" : ""
                }}
                <br />
              </small>
              <b-badge variant="primary">
                {{ mgt.farmservice.minroi }}% - {{ mgt.farmservice.maxroi }}%
                returns
              </b-badge>
              <hr class="mt-3 mb-3" />
              <b-row>
                <b-col cols="6">
                  <h6 class="mb-0 mt-0">
                    {{ formatMoney(mgt.amount) }}
                  </h6>
                  <small variant="dark">Invested</small>
                </b-col>
                <b-col cols="6">
                  <h6 class="mb-0 mt-0">
                    {{
                      formatMoney(
                        mgt.amount +
                          ((mgt.farmservice.minroi + mgt.farmservice.maxroi) /
                            2 /
                            100) *
                            mgt.amount
                      )
                    }}
                  </h6>
                  <small variant="primary">Estimated returns</small>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { formatMoney } from "@/utils/helpers";
import { DateTime as LuxonDateTime } from "luxon";

export default {
  name: "ownership-siebar",
  props: {
    subscription: null
  },
  data() {
    return {
      loading: false,
      LuxonDateTime: LuxonDateTime
    };
  },
  methods: {
    formatMoney,
    computeTotal() {
      if (this.subscription.farmmanagements.length > 0) {
        let totalinvested = this.subscription.amount;

        for (const x of this.subscription.farmmanagements) {
          totalinvested += x.amount;
        }

        return totalinvested;
      }
      return this.subscription.amount;
    }
  }
};
</script>

<style scoped>
#sidebar-right {
  color: rgb(2, 2, 2) !important;
  background-color: #ffffff !important;
  width: 500px !important;
}

.sidebar-title {
  position: absolute;
  top: 12px;
  left: 45px;
}
.moneyTag {
  padding: 15px 10px;
  background: #ebebeb;
  font-size: 17px !important;
}
</style>
